import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface GetHospitalCaseCreditsPayload {
  hospitalId: string;
}

export const getHospitalCaseCredits = createAsyncThunk(
  'hospitalCreditForCaseToCase/get',
  async (payload: GetHospitalCaseCreditsPayload | undefined, thunkAPI) => {
    const hospitalId = payload?.hospitalId;
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    if (!hospitalId) return thunkAPI.rejectWithValue('Hospital ID not found');

    const url = `${_creditForCaseToCase.getHospital}?hospitalId=${hospitalId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      return thunkAPI.rejectWithValue(`Failed to fetch case credits: ${errorText}`);
    }

    const data = await response.json();

    return {
      caseCredits: data.data,
      creditValue: data.creditValue,
      creditSymbol: data.creditSymbol,
      msg: data.status === 'success' ? 'Hospital case credits fetched successfully' : undefined,
    };
  }
);
